// extracted by mini-css-extract-plugin
module.exports = {"selector":"_1oCIr"};